
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("el3Ev", function(module, exports) {

$parcel$export(module.exports, "EditPageLoaderServer", () => $228a47a301acff39$export$99fa8db8497fb663);

var $gwFzn = parcelRequire("gwFzn");

var $dHX7l = parcelRequire("dHX7l");

var $8Hqv7 = parcelRequire("8Hqv7");

var $hp2SH = parcelRequire("hp2SH");

var $jXpbL = parcelRequire("jXpbL");

var $98zed = parcelRequire("98zed");

var $1NBp8 = parcelRequire("1NBp8");

var $kE2cJ = parcelRequire("kE2cJ");
const $228a47a301acff39$export$99fa8db8497fb663 = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>{
    const [isUnpublishedDraft, setIsUnpublishedDraft] = (0, $gwFzn.useState)(false);
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    if (livePageSSRStatus.isTypeKnown && livePageSSRStatus.isLive) // Remove draftShareId if it exists, to avoid persisting it on live doc. If the param exists on live doc, it prevents SSR from preloading live doc title/content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.VIEW_PAGE).name,
        params: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        excludedQueryParams: [
            'draftShareId'
        ]
    });
    (async ()=>{
        const queryResult = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $jXpbL.NativeCollabQuery),
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ],
                ...draftShareId && {
                    draftShareId: draftShareId
                }
            },
            fetchPolicy: 'cache-first',
            context: {
                single: 'true'
            }
        });
        const newUnpublishedDraft = !queryResult.data?.content?.nodes?.[0]?.history?.createdBy;
        if (newUnpublishedDraft !== isUnpublishedDraft) setIsUnpublishedDraft(newUnpublishedDraft);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8Hqv7.FullCycleRender), {
        name: "edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dHX7l.FullPageEditorLoader), {
        isUnpublishedDraft: isUnpublishedDraft,
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        collabEditState: {},
        heartbeatData: {},
        disabled: true
    }))));
};

});


//# sourceMappingURL=EditPageLoaderServer.34c73218.js.map
